export default __webpack_public_path__ + "static/media/last-worked-ss.32b9bdfc.svg";